const CartPage = () => {
  const cartTabs = [...document.querySelectorAll(".cart-page__tab")];
  const steps = [...document.querySelectorAll(".cart-page__step")];
  const clickableSteps = [...document.querySelectorAll(".cart-page__step.clickable")];
  const stepBtnsContainers = [...document.querySelectorAll(".step-btns")];
  const cartPageFooter = document.querySelector(".cart-page__footer");

  const proceedCheckoutBtn = document.querySelector(".proceed-checkout-btn");
  const backBtns = [...document.querySelectorAll(".back-btn")];
  const nextBtn = document.querySelector(".next-btn");
  const placeOrderBtn = document.querySelector(".place-order-btn");

  // const couponInput = document.querySelector(".coupon-input");
  // const applyCouponBtn = document.querySelector(".apply-coupon-btn");
  // const couponValidatingElement = document.querySelector(".checkout_coupon.woocommerce-form-coupon");

  let currentStepIndex = 0;
  
  function changeStep(stepIndex) {
    currentStepIndex = stepIndex;

    cartTabs.forEach((cartTab) => {
      cartTab.classList.remove("active");
    });

    cartTabs[stepIndex].classList.add("active");

    steps.forEach((step, index) => {
      if (index <= stepIndex) {
        step.classList.add("active");
      } else {
        step.classList.remove("active");
      }
    });

    if (stepBtnsContainers && stepBtnsContainers.length > 0) {
      stepBtnsContainers.forEach((stepBtnsContainer) => {
        stepBtnsContainer.classList.remove("active");
      });

      if (stepBtnsContainers[stepIndex]) {
        stepBtnsContainers[stepIndex].classList.add("active");
      }
    };

    if (currentStepIndex === 3) {
      clickableSteps.forEach((clickableStep) => {
        clickableStep.classList.remove("clickable");
      })
    }
  };

  function transferCheckoutDataToThirdStep() {
    const emailInputValue = document.querySelector('#billing_email').value;
    const streetInputValue = document.querySelector('#billing_address_1').value;
    const cityInputValue = document.querySelector('#billing_city').value;
    const postcodeInputValue = document.querySelector('#billing_postcode').value;
    const countryInputValue = document.querySelector('#billing_country').value;
    const companyInputValue = document.querySelector('#billing_company').value;

    const emailInfo = document.querySelector(".checkout-info-item .info.email");
    const addressInfo = document.querySelector(".checkout-info-item .info.address");
    const companyInfo = document.querySelector(".checkout-info-item .info.company");

    emailInfo.textContent = emailInputValue;

    addressInfo.textContent = `${streetInputValue}, ${cityInputValue}, ${postcodeInputValue}, ${countryInputValue}`;

    companyInfo.textContent = companyInputValue;
  }

  if (cartTabs && cartTabs.length > 0) {
    changeStep(currentStepIndex);

    if (proceedCheckoutBtn) {
      proceedCheckoutBtn.addEventListener("click", (e) => {
        e.preventDefault();
        changeStep(1);
      });
    }

    if (backBtns.length > 0) {
      backBtns.forEach((backBtn) => {
        backBtn.addEventListener("click", () => {
          changeStep(currentStepIndex - 1);
        });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        changeStep(2);
        transferCheckoutDataToThirdStep();
      });
    }

    // if (applyCouponBtn && couponInput) {
    //   applyCouponBtn.addEventListener("click", (e) => {
    //     if (couponInput.value.trim() !== "" && couponValidatingElement.classList.contains("valid") ) {
    //       applyCouponBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    //                                     <path d="M18.1637 6.28829L8.16374 16.2883C8.07664 16.3757 7.97314 16.445 7.85919 16.4924C7.74524 16.5397 7.62306 16.564 7.49967 16.564C7.37628 16.564 7.25411 16.5397 7.14016 16.4924C7.0262 16.445 6.92271 16.3757 6.83561 16.2883L2.46061 11.9133C2.3734 11.8261 2.30423 11.7226 2.25703 11.6086C2.20984 11.4947 2.18555 11.3726 2.18555 11.2492C2.18555 11.1259 2.20984 11.0038 2.25703 10.8898C2.30423 10.7759 2.3734 10.6724 2.46061 10.5852C2.54782 10.498 2.65134 10.4288 2.76528 10.3816C2.87922 10.3344 3.00135 10.3101 3.12467 10.3101C3.248 10.3101 3.37012 10.3344 3.48406 10.3816C3.598 10.4288 3.70153 10.498 3.78874 10.5852L7.50045 14.2969L16.8372 4.96172C17.0133 4.7856 17.2522 4.68666 17.5012 4.68666C17.7503 4.68666 17.9892 4.7856 18.1653 4.96172C18.3414 5.13784 18.4404 5.37672 18.4404 5.62579C18.4404 5.87486 18.3414 6.11373 18.1653 6.28985L18.1637 6.28829Z" fill="#0DB852"/>
    //                                   </svg>`;
    //     }; 
    //     if (couponInput.value.trim() !== "" && couponValidatingElement.classList.contains("invalid") ) {
    //       applyCouponBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                                     <path d="M17.5383 10.6633L11.9133 16.2883C11.7372 16.4644 11.4983 16.5633 11.2492 16.5633C11.0001 16.5633 10.7613 16.4644 10.5852 16.2883C10.409 16.1122 10.3101 15.8733 10.3101 15.6242C10.3101 15.3751 10.409 15.1363 10.5852 14.9602L14.6094 10.9375H3.125C2.87636 10.9375 2.6379 10.8387 2.46209 10.6629C2.28627 10.4871 2.1875 10.2486 2.1875 10C2.1875 9.75136 2.28627 9.5129 2.46209 9.33709C2.6379 9.16127 2.87636 9.0625 3.125 9.0625H14.6094L10.5867 5.0375C10.4106 4.86138 10.3117 4.62251 10.3117 4.37344C10.3117 4.12437 10.4106 3.88549 10.5867 3.70937C10.7628 3.53325 11.0017 3.43431 11.2508 3.43431C11.4999 3.43431 11.7387 3.53325 11.9148 3.70937L17.5398 9.33437C17.6273 9.42159 17.6966 9.52521 17.7438 9.6393C17.7911 9.75338 17.8153 9.87567 17.8152 9.99915C17.815 10.1226 17.7905 10.2449 17.743 10.3588C17.6955 10.4728 17.6259 10.5763 17.5383 10.6633Z" fill="#808080"/>
    //                                   </svg>`;
    //       couponInput.classList.add("invalid");
    //     };
    //   });
    // };

    clickableSteps.forEach((clickableStep, index) => {
      clickableStep.addEventListener("click", () => {
        changeStep(index);
      });
    });
  }
}

export default CartPage;